import { Routes } from '@angular/router';

export const wildcardCertificatesRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./wildcard-certificates.component').then(
        (m) => m.WildcardCertificatesComponent
      ),
  },
];
